<template>
  <div>
  <!-- <vue-perfect-scrollbar class="scroll-area" :settings="settings"> -->
    <vs-popup title="Feedback" fullscreen :active.sync="show">
      <div class="iframe-container">
        <iframe
          src="https://dpd.youlabonline.com/users/manage_raters?tk=Bw5flOhtqlAgocf5"
          class="w-full h-full border-0"
        >
        </iframe>
      </div>
    </vs-popup>
    <div class="mb-base">
      <div class="flex justify-between flex-wrap mb-1">
        <div class="w-full lg:w-2/3 xl:w-2/3">
          <vs-row>
            <h3 class="float-left mr-4">Competency</h3>
            <vx-tooltip
              v-if="saveInProgress"
              class="float-left mr-base"
              text="Saving to cloud..."
            >
              <feather-icon
                icon="CloudIcon"
                class="save-in-progress-status-icon"
                svgClasses="text-success"
              /></vx-tooltip>
              <vx-tooltip v-else class="float-left mr-base" 
              :text="$t('editor.personality.saveToCloud')"
              ><feather-icon
              icon="CloudIcon"
              class="save-in-progress-status-icon"
            /></vx-tooltip>
            <vs-row class="personality-options" style="width: auto;">
              <vx-tooltip
                class="mr-4"
                text="Only Reset Priority"
                position="bottom"
              ><vs-button
                :disabled="
                      disableInputField || !localPersonalityData.personalityTraitsDpdBelux
                    "
                @click.stop="onlyResetPriorityPersonalityTraits()"
                size="small"
                color="primary"
                type="flat"
                icon-pack="material-icons"
                icon="low_priority"
              ></vs-button
              ></vx-tooltip>
              <vx-tooltip
                class="mr-4"
                text="Reset All"
                position="bottom"
              ><vs-button
                :disabled="
                      disableInputField || !localPersonalityData.personalityTraitsDpdBelux
                    "
                @click.stop="resetPersonalityTraits()"
                size="small"
                color="primary"
                type="flat"
                icon-pack="material-icons"
                icon="settings_backup_restore"
              ></vs-button
              ></vx-tooltip>
              <vx-tooltip
                class="mr-4"
                text="Get Feedback"
                position="bottom"
              ><vs-button
                :disabled="
                      disableInputField || !localPersonalityData.personalityTraitsDpdBelux
                    "
                size="small"
                color="primary"
                type="flat"
                icon-pack="material-icons"
                @click="feedback"
                icon="supervisor_account"
              ></vs-button
              ></vx-tooltip>
            </vs-row>
          </vs-row>
        </div>
        <div>
          <options
            :previousMove="{ name: 'editor-skills' }"
            :nextMove="{ name: 'editor-projects' }"
          />
        </div>
      </div>
      <!-- <p v-if="!isUserLoggedIn" class="text-danger">
        You are not authenticated. Please login to save your data.
      </p>
      <p v-else-if="internetConnectionStatus">
        Internet Connection Active. Keep editing and your data gets auto-saved.
      </p>
      <p v-else class="text-danger">
        No Internet Connection. Please connect to Internet to save your data.
      </p> -->
      <p v-if="!isUserLoggedIn">
          <span v-if="organizationSlug === 'default'">
            You are not authenticated. <router-link :to="{ name: 'editor-about'}">Login</router-link> to save your data.
          </span>
        <span v-else>
            You are not authenticated. <router-link :to="{ name: 'editor-about-custom'}">Login</router-link> to save your data.
          </span>
      </p>
    </div>
    <div class="main-form mb-base">
      <h5 v-if="!best6Set" class="mb-2 text-dark">
        {{ $t('editor.personality.chooseYourTop6Strengths.p1') }}
        <span class="text-success"><b>{{ $t('editor.personality.chooseYourTop6Strengths.p2') }}</b></span> {{ $t('editor.personality.chooseYourTop6Strengths.p3') }}
      </h5>
      <div class="mb-3" v-else>
        <h5 class="mb-2 text-dark">
          {{ $t('editor.personality.characteristicsThatBestDescribeYou.p1') }}
          <span class="text-success"><b>{{ $t('editor.personality.characteristicsThatBestDescribeYou.p2') }}</b></span> {{ $t('editor.personality.characteristicsThatBestDescribeYou.p3') }}
        </h5>
        <!-- Assign Priority Number -->
        <vs-row
          v-if="Object.keys(personalityData).length"
          class="personality-row mb-2"
        >
          <vs-col
            v-for="(p, index) in localPersonalityData.personalityTraitsDpdBelux"
            :key="index"
            vs-w="4"
            vs-xs="12"
          >
            <div v-if="index < 6">
              <div class="px-1 mb-2">
                <vx-tooltip
                  :text="getPersonalityTraitById(p.id).description"
                  position="right"
                >
                  <div @click.stop="pushPersonality(p.id)">
                    <vs-row
                      class="personality-unit"
                      :class="{
                          'personality-unit--selected': personalityTraitSelected(
                            p.id
                          ),
                        }"
                      vs-align="center"
                      vs-type="flex"
                      vs-justify="center"
                    >
                      <vs-col
                        vs-w="3"
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                      >
                          <span
                            class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary"
                          >
                            <img
                              :src="getPersonalityTraitById(p.id).pngIcon"
                              :alt="getPersonalityTraitById(p.id).title"
                              width="24px"
                              height="24px"
                            />
                          </span>
                      </vs-col>
                      <vs-col
                        vs-w="7"
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="left"
                      >
                        <div class="items-left">
                          <div class="personality-title">
                            {{ getPersonalityTraitById(p.id).title }}
                          </div>
                        </div>
                      </vs-col>
                      <vs-col
                        vs-w="2"
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="left"
                      >
                        <div v-if="p.priorityNumber" class="items-center">
                          <div class="personality-order">
                            {{ p.priorityNumber }}
                          </div>
                        </div>
                      </vs-col>
                    </vs-row>
                  </div>
                </vx-tooltip>
              </div>
            </div>
          </vs-col>
        </vs-row>
      </div>
      <div v-if="best6Set">
        <h5 v-if="!most6Set" class="mb-2 text-dark">
          {{ $t('editor.personality.choose6MoreStrengths.p1') }}
          <span class="text-primary"><b>{{ $t('editor.personality.choose6MoreStrengths.p2') }}</b></span> {{ $t('editor.personality.choose6MoreStrengths.p3') }}
        </h5>
        <div class="mb-3" v-else>
          <h5 class="mb-2 text-dark">
            {{ $t('editor.personality.characteristicsThatMostDescribeYou.p1') }}
            <span class="text-primary"><b>{{ $t('editor.personality.characteristicsThatMostDescribeYou.p2') }}</b></span> {{ $t('editor.personality.characteristicsThatMostDescribeYou.p3') }}
          </h5>
          <!--Assign Priority Number -->
          <vs-row
            v-if="Object.keys(personalityData).length"
            class="personality-row mb-2"
          >
            <vs-col
              v-for="(p, index) in localPersonalityData.personalityTraitsDpdBelux"
              :key="index"
              vs-w="4"
              vs-xs="12"
            >
              <div v-if="index >= 6 && index < 12">
                <div class="px-1 mb-2">
                  <vx-tooltip
                    :text="getPersonalityTraitById(p.id).description"
                    position="right"
                  >
                    <div @click.stop="pushPersonality(p.id)">
                      <vs-row
                        class="personality-unit--most"
                        :class="{
                            'personality-unit--selected-most': personalityTraitSelected(
                              getPersonalityTraitById(p.id).id
                            ),
                          }"
                        vs-align="center"
                        vs-type="flex"
                        vs-justify="center"
                      >
                        <vs-col
                          vs-w="3"
                          vs-type="flex"
                          vs-justify="center"
                          vs-align="center"
                        >
                            <span
                              class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary"
                            >
                              <img
                                :src="getPersonalityTraitById(p.id).pngIcon"
                                :alt="getPersonalityTraitById(p.id).title"
                                width="24px"
                                height="24px"
                              />
                            </span>
                        </vs-col>
                        <vs-col
                          vs-w="7"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div class="items-left">
                            <div class="personality-title">
                              {{ getPersonalityTraitById(p.id).title }}
                            </div>
                          </div>
                        </vs-col>
                        <vs-col
                          vs-w="2"
                          vs-type="flex"
                          vs-justify="left"
                          vs-align="left"
                        >
                          <div v-if="p.priorityNumber" class="items-center">
                            <div class="personality-order">
                              {{ p.priorityNumber }}
                            </div>
                          </div>
                        </vs-col>
                      </vs-row>
                    </div>
                  </vx-tooltip>
                </div>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </div>
      <div class="mb-base">
        <h5 v-if="most6Set" class="mb-2 text-dark">
          {{ $t('editor.personality.characteristicsThatLeastDescribeYou.p1') }}
          <span class="text-warning"><b>{{ $t('editor.personality.characteristicsThatLeastDescribeYou.p2') }}</b></span> {{ $t('editor.personality.characteristicsThatLeastDescribeYou.p3') }}
        </h5>
        <!-- Assign Priority Number -->
        <vs-row
          v-if="Object.keys(personalityData).length"
          class="personality-row mb-4"
        >
          <vs-col
            v-for="(p, index) in sortedPersonalityData"
            :key="index"
            vs-w="4"
            vs-xs="12"
          >
            <div v-if="index < 6 && !best6Set">
              <div class="px-1 mb-2">
                <vx-tooltip :text="p.description" position="right">
                  <div @click.stop="pushPersonality(p.id)">
                    <vs-row
                      class="personality-unit cursor-pointer"
                      :class="{
                          'personality-unit--selected': personalityTraitSelected(
                            p.id
                          ),
                        }"
                      vs-align="center"
                      vs-type="flex"
                      vs-justify="center"
                    >
                      <vs-col
                        vs-w="3"
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                      >
                          <span
                            class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary"
                          >
                            <img
                              :src="p.pngIcon"
                              :alt="p.title"
                              width="24px"
                              height="24px"
                            />
                          </span>
                      </vs-col>
                      <vs-col
                        vs-w="9"
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="left"
                      >
                        <div class="items-left">
                          <!-- recheck -->
                          <div class="personality-title">{{ p.title }}</div>
                        </div>
                      </vs-col>
                      <!-- <vs-col
                        vs-w="2"
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="left"
                      >
                        <div v-if="personalityTraitSelected(p.id)" class="items-center">
                          <div class="personality-order">{{ parseInt(index) + 1 }}</div>
                        </div>
                      </vs-col> -->
                    </vs-row>
                  </div>
                </vx-tooltip>
              </div>
            </div>
            <div v-else-if="index >= 6 && index < 12 && !most6Set">
              <div class="px-1 mb-2">
                <vx-tooltip :text="p.description" position="right">
                  <div @click.stop="pushPersonality(p.id)">
                    <vs-row
                      class="personality-unit cursor-pointer"
                      :class="{
                          'personality-unit--most': best6Set,
                          'personality-unit--selected': personalityTraitSelected(
                            p.id
                          ),
                          'personality-unit--selected-most':
                            best6Set && personalityTraitSelected(p.id),
                        }"
                      vs-align="center"
                      vs-type="flex"
                      vs-justify="center"
                    >
                      <vs-col
                        vs-w="3"
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                      >
                          <span
                            class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary"
                          >
                            <img
                              :src="p.pngIcon"
                              :alt="p.title"
                              width="24px"
                              height="24px"
                            />
                          </span>
                      </vs-col>
                      <vs-col
                        vs-w="9"
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="left"
                      >
                        <div class="items-left">
                          <div class="personality-title">{{ p.title }}</div>
                        </div>
                      </vs-col>
                      <!-- <vs-col
                        vs-w="2"
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="left"
                      >
                        <div v-if="personalityTraitSelected(p.id)" class="items-center">
                          <div class="personality-order">{{ parseInt(index) + 1 }}</div>
                        </div>
                      </vs-col> -->
                    </vs-row>
                  </div>
                </vx-tooltip>
              </div>
            </div>
            <div v-else-if="index >= 12">
              <div class="px-1 mb-2">
                <vx-tooltip :text="p.description" position="right">
                  <div @click.stop="pushPersonality(p.id)">
                    <vs-row
                      class="personality-unit cursor-pointer"
                      :class="{
                          'personality-unit--most': best6Set && !most6Set,
                          'personality-unit--least': most6Set,
                        }"
                      vs-align="center"
                      vs-type="flex"
                      vs-justify="center"
                    >
                      <vs-col
                        vs-w="3"
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                      >
                          <span
                            class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary"
                          >
                            <img
                              :src="p.pngIcon"
                              :alt="p.title"
                              width="24px"
                              height="24px"
                            />
                          </span>
                      </vs-col>
                      <vs-col
                        vs-w="7"
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="left"
                      >
                        <div class="items-left">
                          <div class="personality-title">
                            {{ getPersonalityTraitById(p.id).title }}
                          </div>
                        </div>
                      </vs-col>
                      <vs-col
                        vs-w="2"
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="left"
                      >
                        <div
                          v-if="getCurrentPriorityNumber(p.id)"
                          class="items-center"
                        >
                          <div class="personality-order">
                            {{ getCurrentPriorityNumber(p.id) }}
                          </div>
                        </div>
                      </vs-col>
                    </vs-row>
                  </div>
                </vx-tooltip>
              </div>
            </div>
          </vs-col>
        </vs-row>
      </div>
      <vs-row>
        <vs-col class="px-2 left-side-col" vs-w="6" vs-xs="12">
          <vs-row class="mb-3">
            <label>{{ $t('editor.personality.keepBuildingYourPersonalBrand') }}</label>
          </vs-row>
          <vs-row class="mb-2">
            <vs-radio
              class="mr-3"
              name="Dont Broadcast my personality"
              v-model="localPersonalityData.broadcastPersonalityDpdBelux"
              vs-value="dont-broadcast-my-personality"
              @blur="saveField('saveBroadcastPersonalityDpdBelux')"
              :disabled="disableInputField"
            >
                <span
                  class="text-personality-style"
                  :class="{
                    'broadcast-personality-selected':
                      localPersonalityData.broadcastPersonalityDpdBelux ===
                      'dont-broadcast-my-personality',
                  }"
                >Don't Broadcast my Competency</span>
            </vs-radio>
          </vs-row>
          <vs-row class="mb-2">
            <vs-radio
              class="mr-3"
              name="Show personality statements"
              v-model="localPersonalityData.broadcastPersonalityDpdBelux"
              vs-value="show-personality-statements"
              @blur="saveField('saveBroadcastPersonalityDpdBelux')"
              :disabled="disableInputField"
            >
                <span
                  class="text-personality-style"
                  :class="{
                    'broadcast-personality-selected':
                      localPersonalityData.broadcastPersonalityDpdBelux ===
                      'show-personality-statements',
                  }"
                >
                  {{ $t('editor.personality.statements') }}
                </span>
            </vs-radio>
            <vs-radio
              class="mr-3"
              name="Show cloud tag"
              v-model="localPersonalityData.broadcastPersonalityDpdBelux"
              vs-value="show-cloud-tag"
              @blur="saveField('saveBroadcastPersonalityDpdBelux')"
              :disabled="disableInputField"
            >
                <span
                  class="text-personality-style"
                  :class="{
                    'broadcast-personality-selected':
                      localPersonalityData.broadcastPersonalityDpdBelux ===
                      'show-cloud-tag',
                  }"
                >
                  {{ $t('editor.personality.cloudTags') }}
                </span>
            </vs-radio>
            <vs-radio
              class="mr-3"
              name="Show icons"
              v-model="localPersonalityData.broadcastPersonalityDpdBelux"
              vs-value="show-icons"
              @blur="saveField('saveBroadcastPersonalityDpdBelux')"
              :disabled="disableInputField"
            >
                <span
                  class="text-personality-style"
                  :class="{
                    'broadcast-personality-selected':
                      localPersonalityData.broadcastPersonalityDpdBelux ===
                      'show-icons',
                  }"
                >
                  {{ $t('editor.personality.icons') }}
                </span>
            </vs-radio>
          </vs-row>
        </vs-col>
        <vs-col class="px-2" vs-w="6" vs-xs="12">
          <label>Competency Statements</label>
          <vs-textarea
            class="w-full"
            name="Personality Statements"
            :disabled="disableInputField"
            v-model="localPersonalityData.personalityStatementsDpdBelux"
            @blur="saveField('savePersonalityStatementsDpdBelux')"
          />
        </vs-col>
      </vs-row>
    </div>
  <!-- </vue-perfect-scrollbar> -->
  </div>
</template>

<script>
  // import FeatherIcon from "../../components/FeatherIcon.vue";
  import Options from "../components/Options.vue";
  import constants from "@/constants";
  import axios from '@/axios.js';
  import { saveInputFieldService } from "@/services/editor/personality.service.js";
  // import personalityData from "@/assets/data/personality.js";
  // import _ from "lodash";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";

  export default {
    components: { Options, VuePerfectScrollbar },
    name: "EditorPersonality",
    props: ['personalityData'],
    data() {
      return {
        localData: {},
        localPersonalityData: {},
        competencyId:[],
        idData:[],
        idDataAll:[],
        answers:[],
        constants,
        settings: {
          suppressScrollX: true,
          maxScrollbarLength: 40,
          wheelSpeed: 0.6,
        },
        show:false,
        // personalityData: this.shufflePersonalityData(personalityData),
        sortedPersonalityData: this.personalityData,
      };
    },
    computed: {
      otpSent() {
        return this.$store.state.auth.otpSent;
      },
      saveInProgress() {
        return this.$store.state.editor.saveInProgress;
      },
      isUserLoggedIn() {
        return this.$store.state.auth.isUserLoggedIn;
      },
      usersData() {
        return this.$store.state.users.data;
      },
      personality() {
        return this.$store.state.editor.personality;
      },
      userId() {
        return this.$store.state.auth.user._id;
      },
      internetConnectionStatus() {
        return this.$store.state.users.internetConnectionStatus;
      },
      disableInputField() {
        return !this.isUserLoggedIn || !this.internetConnectionStatus;
      },
      best6Set() {
        if (this.localPersonalityData.personalityTraitsDpdBelux) {
          if (this.localPersonalityData.personalityTraitsDpdBelux.length >= 6) {
            return true;
          }
        }
        return false;
      },
      most6Set() {
        if (this.localPersonalityData.personalityTraitsDpdBelux) {
          if (this.localPersonalityData.personalityTraitsDpdBelux.length >= 12) {
            return true;
          }
        }
        return false;
      },
      organizationId() {
        return this.$store.state.organization.orgData._id;
      },
      organizationSlug() {
        return this.$store.state.organization.organizationSlug;
      },
    },
    watch: {
      usersData(newVal) {
        if (newVal) {
          //// console.log(newVal);
          this.localData = JSON.parse(JSON.stringify(newVal));
        }
      },
      personality(newVal) {
        if (newVal) {
          // // console.log(newVal);
          this.localPersonalityData = JSON.parse(JSON.stringify(newVal));
        }
      },
      localPersonalityData(newVal) {
        if (newVal) {
          // // console.log(newVal);
          this.sortedPersonalityData = this.sortPersonalityData();
          // // console.log(this.sortedPersonalityData);
        }
      },
    },
    methods: {
      feedback(){
        this.show=true;
      },
      shufflePersonalityData(array) {
        let currentIndex = array.length,
          temporaryValue,
          randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
          // Pick a remaining element...
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;

          // And swap it with the current element.
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }

        return array;
      },
      resetPersonalityTraits() {
        this.localPersonalityData.personalityTraitsDpdBelux = [];
        this.saveField("savePersonalityTraitsDpdBelux");
        this.localPersonalityData.personalityStatementsDpdBelux = null;
        for(let i=19;i<=36;i++) {
          this.idDataAll[i]=0;
        }
        // Object Array Merge
        this.answers = JSON.parse(JSON.stringify(Object.assign( {}, this.idDataAll)));
        this.$store
          .dispatch("alex/fetchDetails", this.userId)
          .then(res =>{
            let alexData=
              {
                "_id":res.data._id,
                "answers": this.answers,
                "user_id":res.data.youlabId,
              }
            this.$store
              .dispatch("alex/updateAlex",alexData)
              .then(res =>{

              })
              .catch((err) => {
                throw err;
              })
            // console.log(res.data.youlabId);
          })
          .catch((err) => {
            throw err;
          })
        this.idDataAll=[];
        this.saveField('savePersonalityStatementsDpdBelux');
      },
      onlyResetPriorityPersonalityTraits() {
        if (this.localPersonalityData.personalityTraitsDpdBelux) {
          this.localPersonalityData.personalityTraitsDpdBelux.forEach((pt) => {
            delete pt.priorityNumber;
          });
          this.saveField("savePersonalityTraitsDpdBelux");
        } else {
          return;
        }
      },
      getPersonalityTraitById(id) {
        const p = this.personalityData.find((pd) => pd.id === id);
        return p;
      },
      getCurrentPriorityNumber(id) {
        if (this.localPersonalityData.personalityTraitsDpdBelux) {
          let cpObj = this.localPersonalityData.personalityTraitsDpdBelux.find(
            (pt) => pt.id === id
          );
          if (cpObj) {
            return cpObj.priorityNumber;
          }
          return null;
        }
        return null;
      },
      getNextPriorityNumber() {
        let pn = 0;
        this.localPersonalityData.personalityTraitsDpdBelux.forEach((p) => {
          if (p.priorityNumber > 0) pn = pn + 1;
        });
        return pn + 1;
      },
      sortPersonalityData() {
        // if(this.most6Set) return;

        let allPData = this.personalityData;
        let selectedPData = this.localPersonalityData.personalityTraitsDpdBelux;

        if (!Object.keys(allPData).length) return [];
        allPData = JSON.parse(JSON.stringify(allPData));

        if (!this.isUserLoggedIn) return allPData;

        if (!selectedPData || !selectedPData.length) return allPData;
        selectedPData = JSON.parse(JSON.stringify(selectedPData));

        let sortedData = [];
        let unSelectedData = [];

        selectedPData.forEach((sp) => {
          let spo = Object.keys(allPData).find((p) => {
            return allPData[p].id === sp.id;
          });
          sortedData.push(allPData[spo]);
        });

        let arrOfIds = [];
        selectedPData.forEach((sd) => {
          arrOfIds.push(sd.id);
        });

        Object.keys(allPData).forEach((ap) => {
          if (!arrOfIds.includes(allPData[ap].id)) {
            // // console.log(allPData[ap]);
            unSelectedData.push(allPData[ap]);
          }
        });

        sortedData = sortedData.concat(unSelectedData);

        // // console.log(sortedData);
        return sortedData;
      },
      personalityTraitSelected(id) {
        if (this.localPersonalityData.personalityTraitsDpdBelux) {
          let arrOfIds = [];
          this.localPersonalityData.personalityTraitsDpdBelux.forEach((sd) => {
            arrOfIds.push(sd.id);
          });
          return arrOfIds.includes(id);
        } else {
          return false;
        }
      },
      pushPersonality(id) {
        // // console.log(id, this.localPersonalityData);

        // // console.log(id);

        if (!this.isUserLoggedIn || !this.internetConnectionStatus) return;

        if (this.most6Set && this.getPersonalityTraitById(id).priorityNumber > 0)
          return;

        // if (this.most6Set) return;
        // // console.log("push");

        if(!this.localPersonalityData.personalityTraitsDpdBelux) {
          this.localPersonalityData.personalityTraitsDpdBelux = [];
        }
        const pIndex = this.localPersonalityData.personalityTraitsDpdBelux.findIndex(
          (pI) => pI.id === id
        );

        // // console.log(pIndex);

        // best, most & least not selected
        if (!this.most6Set) {
          if (pIndex === -1) {
            this.localPersonalityData.personalityTraitsDpdBelux.push({ id });
            // Set personality statements
            if(this.localPersonalityData.personalityTraitsDpdBelux.length < 7) {
              const self = this;
              self.localPersonalityData.personalityStatementsDpdBelux = "";
              this.localPersonalityData.personalityTraitsDpdBelux.forEach( pt => {
                self.localPersonalityData.personalityStatementsDpdBelux += self.getPersonalityTraitById(pt.id).description + '\n';
                //alex competency id
                this.competencyId.push(self.getPersonalityTraitById(pt.id).alexCompetencyMapId);
              });
              //let competencyId = {};
              //alex competency map data and talentPrint Api Call Start
              this.comptencyData=[...new Set( this.competencyId)];
              if( this.comptencyData.length==6) {
                for(let i=19;i<=36;i++) {
                  for (let j = 0; j < this.comptencyData.length; j++) {
                    if(i===this.comptencyData[j]){
                      this.idData[i] = 2;
                    }
                  }
                  this.idDataAll[i]=0;
                }

                // Object Array Merge
                this.answers = JSON.parse(JSON.stringify(Object.assign( {}, this.idDataAll, this.idData )));
                this.$store
                  .dispatch("alex/fetchDetails", this.userId)
                  .then(res =>{
                    let alexData=
                      {
                        "_id":res.data._id,
                        "answers": this.answers,
                        "user_id":res.data.youlabId,
                        "flag":"CompetencySync"
                      }
                    this.$store
                      .dispatch("alex/updateAlex",alexData)
                      .then(res =>{

                      })
                      .catch((err) => {
                        throw err;
                      })
                    // console.log(res.data.youlabId);
                  })
                  .catch((err) => {
                    throw err;
                  })
              }
              //alex competency map data and talentPrint Api Call End
              this.saveField('savePersonalityStatementsDpdBelux');
            }

            if (this.localPersonalityData.personalityTraitsDpdBelux.length === 12) {
              this.$vs.notify({
                title:
                  "Would you like to develop this personality characteristic on Priority?",
                text:
                  "Mark the behaviors that you would like to develop and get microlearning content feed on your development charter.",
                fixed: true,
              });
            }
          } else {
            return;
          }
        } else {
          if (pIndex === -1) {
            this.localPersonalityData.personalityTraitsDpdBelux.push({
              id,
              priorityNumber: this.getNextPriorityNumber(),
            });
          } else if (
            !this.localPersonalityData.personalityTraitsDpdBelux[pIndex].priorityNumber
          ) {
            this.localPersonalityData.personalityTraitsDpdBelux[pIndex][
              "priorityNumber"
              ] = this.getNextPriorityNumber();
          } else {
            return;
          }
        }

        // // console.log(this.localPersonalityData.personalityTraitsDpdBelux);

        this.saveField("savePersonalityTraitsDpdBelux");
      },
      async saveField(action, fieldName = null) {
        let fieldIsValid = false;

        if (fieldName) {
          fieldIsValid = await this.$validator.validate(fieldName);

          if (!fieldIsValid) {
            return;
          }
        } else {
          fieldIsValid = true;
        }

        //// console.log(fieldIsValid);

        if (fieldName && !fieldIsValid) {
          return;
        }

        // // console.log(this.localPersonalityData);

        const payload = {
          isUserLoggedIn: this.isUserLoggedIn,
          action,
          localData: this.localData,
          localPersonalityData: this.localPersonalityData,
          userId: this.userId,
          currentThis: this,
        };

        saveInputFieldService(payload);
      },
    },
    created() {
      this.$store.dispatch("editor/toggleRightBar", true);
      this.$store.dispatch("editor/togglePreviewMode", false);
      this.sortedPersonalityData = this.sortPersonalityData();

      //// console.log("contact created");

      if (this.isUserLoggedIn) {
        if (this.usersData && Object.keys(this.usersData).length) {
          this.localData = JSON.parse(JSON.stringify(this.usersData));
          //// console.log(this.localData);
        }
        if (this.personality && Object.keys(this.personality).length) {
          this.localPersonalityData = JSON.parse(
            JSON.stringify(this.personality)
          );
        }
      }

      // For DPD Belux
      document.title = "Competency | Editor | GetBoarded"
    },

  };
</script>

<style scoped>
  .scroll-area {
    position: relative;
    margin: auto;
    width: 100%;
    height: 615px;
    /*height: 1000px;*/
  }
  .personality-unit {
    background: #ffffff;
    border: 1px solid #f4f4f4;
    box-sizing: border-box;
    border-radius: 6px;
  }

  .personality-unit:hover {
    background: rgba(96, 191, 25, 0.06);
    border: 1px solid #60bf19;
    cursor: pointer !important;
  }

  .personality-unit--most {
    background: #ffffff;
    border: 1px solid #f4f4f4;
    box-sizing: border-box;
    border-radius: 6px;
  }

  .personality-unit--most:hover {
    background: rgba(242, 147, 0, 0.06) !important;
    border: 1px solid #f29300 !important;
    cursor: pointer !important;
  }

  .personality-unit--least:hover {
    background: #ffffff !important;
    border: 1px solid #f4f4f4 !important;
    cursor: pointer !important;
  }

  .personality-unit--selected {
    background: rgba(96, 191, 25, 0.06);
    border: 1px solid #60bf19;
  }

  .personality-unit--selected-most {
    background: rgba(242, 147, 0, 0.06) !important;
    border: 1px solid #f29300 !important;
  }

  .personality-title {
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 19px;
    color: #414040;
  }

  .personality-order {
    background: #f29200;
    box-shadow: 0px 4px 8px rgba(255, 172, 46, 0.29);
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-radius: 50%;
    color: white;
  }

  .text-personality-style {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;

    color: #7c7c7c;

    flex: none;
    order: 1;
    flex-grow: 0;
  }

  .broadcast-personality-selected {
    color: #f29300;
  }

  /*.vs-con-textarea >>> .vs-textarea {
    height: 90px !important;
  }*/

  .moving-item {
    transition: all 1s ease;
    -webkit-transition: all 1s ease;
  }

  /*.vs-con-textarea >>> .vs-textarea {
    height: auto !important;
  }*/

  .personality-options >>> .vs-icon {
    font-weight: 900 !important;
    font-size: 20px !important;
    /*border: none;*/
  }
  .iframe-container {
    height:100vh;
  }
</style>
